import { render, staticRenderFns } from "./tool-icon.vue?vue&type=template&id=b0771628&scoped=true&"
import script from "./tool-icon.vue?vue&type=script&lang=js&"
export * from "./tool-icon.vue?vue&type=script&lang=js&"
import style0 from "./tool-icon.vue?vue&type=style&index=0&id=b0771628&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0771628",
  null
  
)

export default component.exports